import React from "react";

const Dial = () => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M68.04 49.52C63.12 49.52 58.36 48.72 53.92 47.28C52.52 46.8 50.96 47.16 49.88 48.24L43.6 56.12C32.28 50.72 21.68 40.52 16.04 28.8L23.84 22.16C24.92 21.04 25.24 19.48 24.8 18.08C23.32 13.64 22.56 8.88 22.56 3.96C22.56 1.8 20.76 0 18.6 0H4.76C2.6 0 0 0.96 0 3.96C0 41.12 30.92 72 68.04 72C70.88 72 72 69.48 72 67.28V53.48C72 51.32 70.2 49.52 68.04 49.52Z"
        fill="black"
      />
    </svg>
  );
};

export default Dial;
